import React from 'react'
import { ProductCart } from '../../components'
import "./cartPage.scss"

const Cart = () => {
  return (
    <div className='cart-page'>
      <ProductCart />
    </div>
  )
}

export default Cart